import React, { useCallback, useEffect, useState } from 'react';
import s from './s.module.less';
import { IPPAServiceSpecialty } from 'types/ppaOnboarding';

interface Props {
    specialties?: IPPAServiceSpecialty[];
    value?: IPPAServiceSpecialty;
    onChange?: (val: IPPAServiceSpecialty) => void;
}

const SpecialtySelector: React.FC<Props> = ({ specialties, value, onChange }) => {
    const [val, setVal] = useState<IPPAServiceSpecialty>();

    useEffect(() => {
        if (value) {
            setVal(value);
        }
    }, [value]);

    const handleClick = useCallback((v: IPPAServiceSpecialty) => {
        setVal(v);
        onChange?.(v);
    }, [onChange]);

    return (
        <div className={s.specialtiesGrid}>
            {specialties?.map((specialty, index) => {
                const condition = specialty.commonCondition?.split(',') || [];
                return (
                    <div
                        key={index}
                        className={`${s.specialtyCard} ${specialty.id === val?.id ? s.selected : ''}`}
                        onClick={() => handleClick(specialty)}
                    >
                        <div className={s.cardContent}>
                            <div className={s.iconSection}>
                                <div className={s.iconCircle}>
                                    <img src={specialty.iconUri} className={s.icon} />
                                </div>
                            </div>
                            <div className={s.textSection}>
                                <div className={s.titleRow}>
                                    <div className={s.titleWithBadge}>
                                        <h3>{specialty.specialtyName}</h3>
                                        <div className={s.badge}>
                                            {condition.length} conditions
                                        </div>
                                    </div>
                                    {specialty.id === val?.id && (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M10.0004 19.6004C15.3023 19.6004 19.6004 15.3023 19.6004 10.0004C19.6004 4.69846 15.3023 0.400391 10.0004 0.400391C4.69846 0.400391 0.400391 4.69846 0.400391 10.0004C0.400391 15.3023 4.69846 19.6004 10.0004 19.6004ZM14.4489 8.44892C14.9175 7.98029 14.9175 7.22049 14.4489 6.75186C13.9803 6.28323 13.2205 6.28323 12.7519 6.75186L8.80039 10.7033L7.24892 9.15186C6.78029 8.68323 6.02049 8.68323 5.55186 9.15186C5.08323 9.62049 5.08323 10.3803 5.55186 10.8489L7.95186 13.2489C8.42049 13.7175 9.18029 13.7175 9.64891 13.2489L14.4489 8.44892Z" fill="#0E62F4" />
                                        </svg>
                                    )}
                                </div>
                                <p className={s.description} dangerouslySetInnerHTML={{ __html: specialty.description }} />
                            </div>
                        </div>
                        {specialty.id === val?.id && (
                            <>
                                <div className={s.divider} />
                                <div className={s.conditionsSection}>
                                    <div className={s.conditionsTitle}>Conditions covered:</div>
                                    <div className={s.conditionsGrid}>
                                        {condition?.map((item, inx) => (
                                            <div key={inx} className={s.conditionBadge}>
                                                {item}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default SpecialtySelector;
